var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8018 9.53144H3.21621L9.18418 3.84707C9.49668 3.54941 9.50879 3.05488 9.21113 2.74238C8.91387 2.43027 8.41934 2.41777 8.10645 2.71542L1.29082 9.20761C0.995898 9.50292 0.833008 9.89511 0.833008 10.3127C0.833008 10.7299 0.995898 11.1225 1.30449 11.4307L8.10684 17.9096C8.25801 18.0537 8.45176 18.1252 8.64551 18.1252C8.85176 18.1252 9.05801 18.0439 9.21152 17.8826C9.50918 17.5701 9.49707 17.076 9.18457 16.7783L3.1916 11.0939H18.8018C19.233 11.0939 19.583 10.7439 19.583 10.3127C19.583 9.88144 19.233 9.53144 18.8018 9.53144Z",
    fill: "#95AAC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.2273702fd5d856cc4e86266daf8bc1c3.svg";
export { ForwardRef as ReactComponent };